import type { Language } from "../../../../shared/api.ts";
import { Segmented } from "@/components/ui/segmented.tsx";
import { useI18n } from "@/i18n/index.tsx";

/** UA / EN switch for pages without the user menu. */
export function LanguageSwitch({ className }: { className?: string }) {
  const { t, language, setLanguage } = useI18n();
  return (
    <Segmented<Language>
      value={language}
      onValueChange={setLanguage}
      label={t.common.language}
      size="sm"
      className={className}
      options={[
        { value: "uk", label: <span lang="uk">{t.common.languages.uk}</span> },
        { value: "en", label: <span lang="en">{t.common.languages.en}</span> },
      ]}
    />
  );
}
